export default new (class AccordionSimple {
    constructor() {
        this.accordion = 'accordion-simple';
        this.accordionContent = 'accordion-content-simple';
        this.accordionBtn = 'accordion-btn-simple';
        this.initHandler()
    }

    /**
     * @description Init handler.
     */
    initHandler() {
        document.addEventListener("DOMContentLoaded", () => {
            document.querySelectorAll(`.${this.accordion}`).forEach((item) => {
                if(item.classList.contains('open-load')) {
                    item.querySelector(`.${this.accordionContent}`).style.maxHeight = item.querySelector(`.${this.accordionContent}`).scrollHeight + 'px';
                }

                item.addEventListener('click', (e) => {
                    if(e.target.tagName.toLowerCase() !== 'a') {
                        e.preventDefault();
                        item.classList.toggle('open')
                        document.querySelectorAll(`.${this.accordion}`).forEach((itemTmp) => {
                            itemTmp.classList.remove('open-load')
                            if(item != itemTmp) {
                                itemTmp.classList.remove('open')
                                if(itemTmp.querySelector(`.${this.accordionContent}`))
                                    itemTmp.querySelector(`.${this.accordionContent}`).removeAttribute('style')
                            }
                        });

                        if(item.classList.contains('open')) {
                            item.querySelector(`.${this.accordionContent}`).style.maxHeight = item.querySelector(`.${this.accordionContent}`).scrollHeight + 'px';
                        }
                        else {
                            item.querySelector(`.${this.accordionContent}`).removeAttribute('style')
                        }
                    }
                });
            });
        });
    }
})()
